<template>
  <span>
    <template v-if="city">
      {{city}},
    </template>
    {{state}}
  </span>
</template>

<script>
import _ from 'lodash';
import API from '@/api';

export default {
  name: 'LocationLabel',
  props: {
    listing: {
      type: Object,
    },
  },
  data() {
    return {
      city: '',
      state: '',
    };
  },
  watch: {
    listing() {
      this.loadLocation();
    }
  },
  methods: {
    async loadLocation() {
      const placeId = this.listing.googlePlaceId;
      const mapsResponse = await API.map.searchCode({ placeId });

      const addresses = _.get(mapsResponse, '[0].address_components', []);

      this.city = _.get(addresses.find(address => address.types.some(type => type === 'locality')), 'short_name', '');
      this.state = _.get(addresses.find(address => address.types.some(type => type === 'administrative_area_level_1')), 'short_name', '');
    },
  },
  mounted() {
    this.loadLocation();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LocationLabel.vue